import { FC } from "react";

import { GenericUploadColumnConflictError } from "@ryde/shared";

import { ColumnConflictsTable } from "./column-conflicts-table";

interface IResolveColumnConflictsTableProps {
  errorType: GenericUploadColumnConflictError;
}

export const ResolveColumnConflictsTable: FC<
  IResolveColumnConflictsTableProps
> = ({ errorType: _errorType }) => {
  return <ColumnConflictsTable />;
};
